import React from "react";
import '../styles/home.css'
import '../components/carousel.js'
import Aboutme from "./aboutme.js";
import Tree from "./tree.js";
import Contact from "./contact.js";
import Header from "./header.js";
import { ProjectCard } from "./projectCard.tsx";

import image1 from '../assets/images/image1.png';
import image3 from '../assets/images/image3.PNG';
// import image6 from '../assets/images/image6.jpeg';
import thesis_image from '../assets/images/thesis_image.png'
import anicare_poster from '../assets/images/anicate_poster.png'
// import moventracProject from '../assets/posteri.pdf';
import anicareThesis from '../assets/kypsyysnäyte.pdf'
import anicareProject from '../assets/posteri_anicare.pdf'
import jenkinsImage from '../assets/images/all-tests.png';
import twitchImage from '../assets/images/TwitchVoting.png';

const projects = [
    {
      title: 'Enhancing usability and testability in an Angular application',
      image: thesis_image,
      description: 'This thesis focuses on implementing unit testing into an Angular application and establishing a testing strategy for critical components. Additionally, I re-engineered the data layer with a local database to support an offline-first approach, drastically improving performance and accessibility in low-connectivity scenarios.',
      technologies: ['Angular', 'Jasmine', 'Karma', 'SQLite'],
      link: anicareThesis
    },
    {
      title: 'Twitch Vote Application',
      image: twitchImage,
      description: 'A Twitch interaction application. The application allows Twitch streamers to play real-time quizzes with their viewers. Viewers can participate in the quiz by voting for the correct answer using Twitch chat commands. ',
      technologies: ['.NET', 'EF Core', 'SignalR', 'React'],
      link: 'https://github.com/JoneMus/TwitchVoteAPI'
    },
    {
      title: 'Climate Change Visualization Tool',
      image: image3,
      description: 'This web application, developed by second-year students at Oulu University of Applied Sciences, visualizes climate change data. Built with ReactJS and a Java Spring Boot REST API, it allows users to create, customize, and share visualization views via unique URLs.',
      technologies: ['React', 'Spring Boot', 'MySQL'],
      link: 'https://github.com/Sovellusprojekti-Ryhma-8/Climate-change-visualization-tool'
    },
    {
      title: 'Python Quality Pipeline With Jenkins',
      image: jenkinsImage,
      description: 'This project demonstrates a CI/CD pipeline built with Jenkins and Python. Jenkins executes Pytest unit tests with coverage reporting, and enforces PEP 8 coding standards via Flake8. The system acts as a quality gate, preventing flawed code from merging into the main branch.',
      technologies: ['Jenkins', 'Python', 'Pytest', 'Flake8'],
      link: 'https://github.com/JoneMus/Jenkins-pyhton-demo'
    },
    {
      title: 'Anicare application development',
      image: anicare_poster,
      description: 'This project focused on implementing remote device management tools within an existing application. I handled the full-stack development process, from creating backend APIs to designing the UI and performing real-device testing. Key features included user-controlled power states (shutdown, sleep, wake), all finalized in a major production release.',
      technologies: ['Angular', 'PHP', 'MySQL'],
      link: anicareProject
    },
    {
      title: 'Swipper',
      image: image1,
      description: 'This international collaboration between Oamk and Fontys universities created a platform for users to add or search for animals. The Match page allows users to swipe right to like animals or left to revisit them later.',
      technologies: ['React Native', 'JavaScript', 'Figma'],
      link: 'https://github.com/JoneMus/Swipper_frontend'
    },
    // {
    //   title: 'Moventrac Project',
    //   image: image6,
    //   description: 'The project developed a mobile app that connects to a wearable sensor, providing real-time feedback on athletic training. Users can create exercises, record reference data, and receive performance insights. The demo aimed to assess consumer interest and market potential.',
    //   technologies: ['React Native', 'Bluetooth Low Energy'],
    //   link: moventracProject
    // }
  ];

export default function Home() {
  const [showAllProjects, setShowAllProjects] = React.useState(false);

  const displayedProjects = showAllProjects ? projects : projects.slice(0, 3);
  const hasMoreProjects = projects.length > 3;

    return (
    <div className="min-h-screen bg-gradient-to-b from-stone-800 via-stone-900 to-stone-950 text-white relative overflow-x-hidden">
      {/* Tree decorations */}
      {/* <Tree/> */}
      <Tree top="true"/>
      {/* <Tree inverted="true"/> */}
      <Tree inverted="true" top="true"/>

      {/* Main content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Header/>
        
        {/* Projects Section */}
        <section className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {displayedProjects.map((project, index) => (
              <ProjectCard key={index} {...project} 
              className={index >= 3 && showAllProjects ? 'animate-fadeInUp' : ''}
              style={index >= 3 && showAllProjects ? { animationDelay: `${(index - 3) * 0.1}s` } : {}}
              />
            ))}
          </div>
          
          {/* See More Button */}
          {hasMoreProjects && (
            <div className="flex justify-center mt-6">
               <button
                onClick={() => setShowAllProjects(!showAllProjects)}
                className="group flex items-center gap-2 text-amber-200/80 hover:text-amber-100 transition-all duration-300"
              >
                <span>{showAllProjects ? 'Show Less' : `See More (${projects.length - 3} more)`}</span>
                <svg 
                  className={`w-5 h-5 transition-transform duration-300 ${showAllProjects ? 'rotate-180' : ''}`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M19 9l-7 7-7-7" 
                  />
                </svg>
              </button>
            </div>
          )}
        </section>
        
        <Aboutme /> 
        <Contact/>
      </div>
    </div>
  );
}
       
